import type { CatalogProduct } from './catalog.models';

export function galleryForProduct(p: CatalogProduct): string[] {
  if (p.gallery?.length) {
    return p.gallery;
  }
  return p.image ? [p.image] : [];
}

export function discountPercent(p: CatalogProduct): number | null {
  if (!p.oldPrice) {
    return null;
  }
  const oldVal = parseInt(p.oldPrice.replace(/[^0-9]/g, ''), 10);
  if (!oldVal || oldVal <= p.priceValue) {
    return null;
  }
  return Math.round(((oldVal - p.priceValue) / oldVal) * 100);
}

/** Formato de precio como en el catálogo actual ($24,990). */
export function formatPriceMx(value: number): string {
  return '$' + value.toLocaleString('en-US');
}
